import { IPagination } from 'models';
import {
	failureActionHandler,
	requestActionHandler,
	successActionHandler,
} from 'store';
import injectReducer from 'store/injectReducer';
import * as types from 'modules/admin-panel/pages/results/ActionTypes';
import {
	IPersonaRole,
	IPersonaSatisfaction,
	IPersonaReducer,
	IPersonaTrendData,
	IPersonaTrendsData,
	IResultComments,
	ICommentsWordcloud,
} from 'modules/admin-panel/pages/results/models';
import { COMMENT_TYPES } from 'modules/admin-panel/utils';

export const InitialPersonaReducer: IPersonaReducer = {
	activeCommentType: COMMENT_TYPES.all,
	isLoading: false,
	isCommentsLoading: false,
};

export default injectReducer(InitialPersonaReducer, {
	[types.GET_PERSONA_DETAILS.REQUEST]: requestActionHandler,
	[types.GET_PERSONA_COMMENTS.REQUEST]: (
		state: IPersonaReducer,
	): IPersonaReducer => ({
		...state,
		isCommentsLoading: false,
	}),
	[types.GET_PERSONA_COMMENTS_WORDCLOUD.REQUEST]: (
		state: IPersonaReducer,
	): IPersonaReducer => ({
		...state,
		isCommentsLoading: false,
	}),

	[types.GET_PERSONA_DETAILS.FAILURE]: failureActionHandler,
	[types.GET_PERSONA_COMMENTS.FAILURE]: (
		state: IPersonaReducer,
		action: { payload: Error },
	): IPersonaReducer => ({
		...failureActionHandler(state, action),
		isCommentsLoading: false,
	}),
	[types.GET_PERSONA_COMMENTS_WORDCLOUD.FAILURE]: (
		state: IPersonaReducer,
		action: { payload: Error },
	): IPersonaReducer => ({
		...failureActionHandler(state, action),
		isCommentsLoading: false,
	}),

	[types.GET_PERSONA_DETAILS.SUCCESS]: (
		state: IPersonaReducer,
		{
			payload,
		}: {
			payload: {
				trends: IPersonaTrendsData<IPersonaTrendData>;
				roles: IPersonaRole[];
				satisfaction: IPersonaSatisfaction;
				comments: IPagination<IResultComments[]>;
			};
		},
	): IPersonaReducer => {
		const {
			serviceTrends,
			firstPerformanceSliderName,
			secondPerformanceSliderName,
			thirdPerformanceSliderName,
		} = payload.trends;
		return {
			...successActionHandler(state),
			...payload,
			serviceTrends,
			performanceSlidersNames: {
				firstPerformanceSliderName,
				secondPerformanceSliderName,
				thirdPerformanceSliderName,
			},
		};
	},

	[types.RESET_PERSONA_DETAILS]: (): IPersonaReducer => InitialPersonaReducer,

	[types.GET_PERSONA_COMMENTS.SUCCESS]: (
		state: IPersonaReducer,
		{ payload }: { payload: IPagination<IResultComments[]> },
	): IPersonaReducer => ({
		...successActionHandler(state),
		comments: payload,
	}),

	[types.GET_PERSONA_COMMENTS_WORDCLOUD.SUCCESS]: (
		state: IPersonaReducer,
		{ payload }: { payload: ICommentsWordcloud },
	): IPersonaReducer => ({
		...successActionHandler(state),
		commentsWordcloud: payload,
	}),

	[types.SET_PERSONA_ACTIVE_COMMENT_TYPE]: (
		state: IPersonaReducer,
		{ payload }: { payload: COMMENT_TYPES },
	): IPersonaReducer => ({
		...state,
		activeCommentType: payload,
	}),
});
